<template>
    <component :is="tileComponent" class="layout-tile" :class="tileClasses" :to="route">
        <div class="flex min-w-0 gap-x-4">
            <image-tile v-if="image" :image="image"></image-tile>
            <div class="flex flex-col" :class="heading && excerpt ? 'justify-around' : ''">
                <content-subheading
                    v-if="heading"
                    :heading="heading"
                    :headingComponent="headingComponent"
                ></content-subheading>
                <content-text v-if="excerpt" :html="excerpt"></content-text>
            </div>
        </div>
        <!-- Actions Go Here -->
    </component>
</template>

<script>
export default {
    name: 'LayoutTile',
    props: {
        route: {
            required: false,
            type: [String, Object],
            default: null,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-white hover:bg-zinc-50',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'p',
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
    },
    computed: {
        tileComponent() {
            return this.route ? 'router-link' : 'div';
        },
        tileClasses() {
            const cls = {};
            cls['flex justify-between gap-x-6 p-4'] = true;
            cls[this.color] = true;
            return cls;
        },
    },
};
</script>
